var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isShow ? _c('portal', {
    attrs: {
      "to": "lm-modal"
    }
  }, [_c('div', {
    staticClass: "Popup__depth3"
  }, [_c('div', {
    staticClass: "Popup__background"
  }), _c('div', {
    staticClass: "Location__delete-location-popup Popup__container Popup__size-sm"
  }, [_c('div', {
    staticClass: "Popup__top"
  }, [_vm.isTypeLocation ? _c('h5', {
    staticClass: "Popup__title"
  }, [_vm._v(_vm._s(_vm.locationInfo.name) + " " + _vm._s(_vm.tt('삭제')))]) : _c('h5', {
    staticClass: "Popup__title"
  }, [_vm._v(_vm._s(_vm.tt('보관함 삭제')))]), _c('button', {
    staticClass: "Popup__close-btn",
    on: {
      "click": _vm.hide
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/popup-close.svg"),
      "alt": "close"
    }
  })])]), _c('div', {
    staticClass: "Popup__content"
  }, [_vm.isTypeLocation ? _c('p', {
    staticClass: "Popup__plain-text"
  }, [_vm._v(" " + _vm._s(_vm.locationInfo.name) + " " + _vm._s(_vm.tt('위치를 삭제하시겠습니까?')) + " ")]) : _c('p', {
    staticClass: "Popup__plain-text"
  }, [_vm._v(" " + _vm._s(_vm.tt('보관함을 정말로 삭제하시겠습니까?'))), _c('br'), _vm._v(" " + _vm._s(_vm.tt('보관함을 사용중인 모든 연구실에서 보관함이 삭제됩니다.')) + " ")])]), _c('div', {
    staticClass: "Popup__bottom"
  }, [_c('div', {
    staticClass: "Popup__delete-btn-group Popup__btn-group"
  }, [_c('button', {
    staticClass: "Btn__close",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('취소')) + " ")]), _c('button', {
    staticClass: "Btn__delete",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('삭제')) + " ")])])])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }